import {
    usePlainList
  } from '@inmagik/react-crud'
  import { API_URL } from '../constants'
import { Toponimo } from '../types'
  
  export function useToponimiList(params: Record<string, string> = {}) {
    return usePlainList<Toponimo>(`${API_URL}/bilance/toponimo`, params)
  }
  